// src/tareas/listadoTareasCreadas.jsx
import React, { useEffect, useState } from "react";
import { Global } from "../helpers/Global";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const formatearFecha = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString();
};

export const ListadoTareasCreadas = ({ embebido = false }) => {
  const [tareas, setTareas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTareas = async () => {
      try {
        const res = await fetch(`${Global.url}tareas/mis-creadas`, {
          headers: authHeaders(),
        });
        const data = await res.json().catch(() => []);
        if (!res.ok) {
          console.error("Error al cargar tareas creadas:", data);
          setError(data.message || "No se pudieron cargar las tareas");
          return;
        }
        setTareas(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Error de red al cargar tareas creadas:", e);
        setError("Error de red al cargar las tareas");
      } finally {
        setCargando(false);
      }
    };

    fetchTareas();
  }, []);

  return (
    <div
      className={
        "tabla-clientes" + (embebido ? " tabla-clientes--embebida" : "")
      }
    >
      {!embebido && <h2>Tareas creadas por mí</h2>}

      {cargando && <p>Cargando tareas…</p>}
      {error && (
        <p style={{ color: "#b02a37", fontWeight: 600, marginBottom: 12 }}>
          {error}
        </p>
      )}

      {!cargando && !error && tareas.length === 0 && (
        <p style={{ fontStyle: "italic" }}>
          No has creado ninguna tarea todavía.
        </p>
      )}

      {!cargando && !error && tareas.length > 0 && (
        <table className="tabla-listado-clientes tabla-listado-tareas-creadas">
          <thead>
            <tr>
              <th>Título</th>
              <th>Prioridad</th>
              <th>Estado global</th>
              <th>Creación</th>
              <th>Vencimiento</th>
              <th className="col-peticiones">Peticiones</th>
            </tr>
          </thead>
          <tbody>
            {tareas.map((t) => (
              <tr key={t.id}>
                <td>{t.titulo}</td>

                <td>
                  <span
                    className={`badge-prioridad badge-prioridad--${
                      t.prioridad || "normal"
                    }`}
                  >
                    {t.prioridad || "normal"}
                  </span>
                </td>

                <td>{t.estado_global}</td>

                <td>{formatearFecha(t.fecha_creacion)}</td>

                <td>{formatearFecha(t.fecha_vencimiento)}</td>

                <td className="col-peticiones">
                    <div className="peticiones-horizontal">
                        <strong>Total:</strong> {t.total_peticiones} &nbsp;|&nbsp;
                        Pend.: {t.pet_pendientes} &nbsp;|&nbsp;
                        Curso: {t.pet_en_curso} &nbsp;|&nbsp;
                        Res.: {t.pet_resueltas} &nbsp;|&nbsp;
                        Rech.: {t.pet_rechazadas} &nbsp;|&nbsp;
                        Canc.: {t.pet_canceladas}
                    </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ListadoTareasCreadas;
